import { ArrowPathRoundedSquareIcon } from "@heroicons/react/24/outline";
import { FunnelIcon } from "@heroicons/react/24/solid";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useRecoilState } from "recoil";
import MaterialInvoiceTable from "../../../../../components/tables/MaterialInvoiceTable";
import { isFromRediInvoice } from "../../InvoiceCapture/atoms/atoms";
import useGetActivityHistoryById from "../../InvoiceCapture/hooks/useGetActivityHistoryId";
import { IVendorInvoiceDetails } from "../../InvoiceCapture/types";
import ReconcilliationForm from "../forms/ReconcilliationForm";
import ReconcilliationFilter from "../ReconcilliationFilter";
import { useGetPendingReconciliationInvoices } from "../hooks/useGetPendingReconciliationInvoices";

interface IReconcilliationTable {}

const ReconcilliationTable: React.FC<IReconcilliationTable> = () => {
  const {
    data: invoiceData,
    isFetching: vendorInvoiceFetching,
    isSuccess: getVendorInvoiceSuccess,
  } = useGetPendingReconciliationInvoices();

  const { data: activityHistoryData, mutate: getactivityHistoryById } =
    useGetActivityHistoryById();

  const [filter, setFilter] = useState(false);
  const [filteredRecon, setFilteredRecon] = useState<any>([]);
  const [isSearching, setIsSearching] = useState(false);
  const [invoiceTableData, setInvoiceTableData] = useState<any[]>([]);
  const [isShowInvoice, setShowInvoice] = useState(false);
  const [viewData, setViewData] = useState<any>({});

  const [isFromRedirection, setIsFromRedirection] =
    useRecoilState(isFromRediInvoice);
  useEffect(() => {
    if (getVendorInvoiceSuccess && invoiceData) {
      setInvoiceTableData(invoiceData?.data);
    }
  }, [invoiceData?.data]);

  // View data from recent act
  let location = useLocation();

  let recordIdFromRecent;
  if (location.state != null) {
    recordIdFromRecent = location.state;
  }

  useEffect(() => {
    if (
      recordIdFromRecent?.moduleName === "Vendor Invoice" &&
      invoiceTableData?.length > 0 &&
      isFromRedirection
    ) {
      const filteredData = invoiceTableData?.filter(
        (x) => x.vendorInvoiceId === Number(recordIdFromRecent.recordId)
      )[0];
      onClickBatchId(filteredData);
      setIsFromRedirection(false);
    }
  }, [recordIdFromRecent, invoiceTableData]);

  const onClickCancelShow = () => {
    setShowInvoice(false);
  };

  const getMaskedBankAccount = (
    bankAccount: string | undefined
  ): string | null => {
    return bankAccount ? bankAccount.replace(/.(?=.{4})/g, "x") : "N/A";
  };

  function formatDate(date) {
    if (!date) {
      return "N/A";
    }
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
    return [month, day, year].join("/");
  }

  const getDescription = (rowData): string => {
    if (rowData?.length === 0) {
      return "Account#: N/A DUE N/A; Service N/A to N/A";
    }
    const autoPayDescription = rowData?.autoPayName
      ? rowData?.autoPayName?.toLowerCase() === "eft"
        ? getMaskedBankAccount(rowData?.bankAccount)
        : `AUTOPAY ${getMaskedBankAccount(rowData?.bankAccount)}`
      : "";
    const accountNumber = rowData?.accountNumber
      ? rowData?.accountNumber
      : "N/A";
    const dueDate = formatDate(rowData?.duedate);
    const servicePeriodDate = formatDate(rowData?.servicePeriodDate);
    const billingPeriodEndDate = formatDate(rowData?.billingPeriodEndDate);
    const serviceDateRange = `Service date ${servicePeriodDate} to ${billingPeriodEndDate} `;

    return `Account#: ${accountNumber} ${autoPayDescription} DUE ${dueDate}; ${serviceDateRange} `;
  };
  const onClickBatchId = (rowdata: IVendorInvoiceDetails) => {
    const rowDescription = getDescription(rowdata);
    setShowInvoice(true);
    setViewData({
      ...rowdata,
      bankReferenceDate: rowdata?.bankReferenceDate
        ? rowdata?.bankReferenceDate?.slice(0, 10)
        : null,
      description: rowDescription,
    });
  };

  const matColumns = [
    {
      title: "Batch Id",
      field: "id",
      render: (rowdata) => {
        return (
          <div
            className="blueAndBold underline cursor-pointer "
            onClick={() => {
              getactivityHistoryById(rowdata?.id);
              onClickBatchId(rowdata);
            }}
          >
            {rowdata.id}
          </div>
        );
      },
    },
    {
      title: "Filename",
      field: "invoiceImageAttachment",
      render: (rowdata) => {
        return (
          <div className="truncate w-40">{rowdata.invoiceImageAttachment}</div>
        );
      },
    },
    {
      title: "Corporate Office No.",
      field: "storeNumber",
    },
    {
      title: "Bank Account",
      field: "",
      render: (rowdata) => {
        return rowdata.bankAccount
          ? rowdata.bankAccount.replace(/.(?=.{4})/g, "x")
          : null;
      },
    },
    {
      title: "Service Account No.",
      field: "accountNumber",
    },
    {
      title: "Date Created",
      field: "createdDate",
      render: (rowdata) => {
        return (
          <div>
            {rowdata.createdDate
              ? new Date(rowdata.createdDate).toLocaleDateString()
              : "unspecified"}
          </div>
        );
      },
    },
  ];
  return (
    <>
      <div className="">
        {isShowInvoice ? (
          <div className="relative">
            <ReconcilliationForm
              onClickCancelShow={onClickCancelShow}
              rowData={viewData}
              setShowInvoice={setShowInvoice}
              activityHistoryData={activityHistoryData}
            />
          </div>
        ) : (
          <>
            <div className="flex gap-2 items-center py-2">
              <div>
                <ArrowPathRoundedSquareIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
              </div>
              <div className="flex flex-col leading tight">
                <h3 className="text-xs font-medium text-gray-500">
                  Vendor Invoice Processing
                </h3>
                <h1 className="mr-auto font-bold text-primary text-md uppercase">
                  Batch List
                </h1>
              </div>
            </div>
            <div className="text-xs  space-y-2">
              <div className="ml-auto flex justify-between pb-2 ">
                <div className="space-x-4 mr-6 ">
                  <button
                    className="hover:scale-90 transition duration-500 focus:bg-primary focus:text-white flex justify-center items-center shadow-md px-3 py-1 h-7 text-xs gap-x-2 font-semibold text-primary border hover:bg-primary selected hover:text-white border-primary rounded-md"
                    onClick={() => {
                      setFilter(!filter);
                    }}
                  >
                    <div>Filter By</div>
                    <FunnelIcon className="h-3 w-3 focus:bg-primary" />
                  </button>
                </div>
              </div>
            </div>
            <main className="flex flex-row pt-2">
              {filter && (
                <div className="overflow-y-auto  flex-col flex-grow bg-white">
                  <ReconcilliationFilter
                    data={invoiceTableData}
                    setFilteredRecon={setFilteredRecon}
                    setIsSearching={setIsSearching}
                  />
                </div>
              )}
              <div
                className={
                  !filter
                    ? "false w-full h-5/6 bg-white overflow-x-auto box-shadow  "
                    : "w-4/5 h-5/6 bg-white overflow-y-auto box-shadow"
                }
              >
                <MaterialInvoiceTable
                  columns={matColumns}
                  data={isSearching ? filteredRecon : invoiceTableData}
                  isLoading={vendorInvoiceFetching}
                />
              </div>
            </main>
          </>
        )}
      </div>
    </>
  );
};

export default ReconcilliationTable;
